<template lang="pug">
  div.waste-generators.legal-entities
    e-toolbar(
    :items="items"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"
    )
    e-table(
    :items="items"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showCheckbox="false"
    :fetchOpenedRowData="fetchOpenedRowData"
    )
      template(slot="expandedRow" slot-scope="props")
        e-progress(
        :loading="props.loading"
        )
        e-table(
        v-if="getOpenedRowItems(props.row)"
        :items="getOpenedRowItems(props.row)"
        :showCheckbox="false"
        @deleteItem="logger"
        @editItem="logger"
        :tableHeightCoef="0.5"
        :autoRoutingOnPagination="false"
        :autoRoutingOnSort="false"
        :tableId="`${$route.name}-expandedTable`"
        @sortAndPaginate="props.reFetchOpenedRowData(props.row, $event)"
        )
    router-view
</template>

<script>
  import {wasteGenerators} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import {NORMATIVE_TYPE_LEGAL} from "../../config/config"
  import {billing} from "../../api/api-endpoints"

  export default {
    mixins: [tableMixin],
    methods: {
      logger (item) {
        console.log(item.id)
      },
      getOpenedRowItems (row) {
        return this.$store.getters.readUrlEndpoint(`${row.id}`)
      },
      fetchOpenedRowData (row, sort, paginate) {
        return this.$store.dispatch('updateUrlEndpoint', {
          endpoint: `${row.id}`,
          url: billing.normativeBranchs({
            query: {
              _id: row.id,
              sort: sort,
              ...paginate
            }
          }, NORMATIVE_TYPE_LEGAL),
          params: {
            disableGlobalError: true
          }
        })
      },
      getEndpoint (route, fromRoute) {
        return wasteGenerators.legals(route)
      },
      getDeleteUrl (id) {
        return wasteGenerators.legalDelete(id)
      }

    }
  }
</script>
